import styled from 'styled-components'

export const FillerAtom = styled.div<{ $height?: number }>`
  min-height: ${({ $height }) => $height ?? 100}px;
`
